import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/auth/ForgotPasswordPage/ForgotPasswordPage.tsx");
